module.exports = __webpack_public_path__ + "static/img/canteen-menu.3321ab66.svg";